import type { Form } from '../../../../common/types/form';
import type { Fax } from '../../../../common/types/client';

const faxForm: Form<Fax> = {
  key: 'faxes',
  title: 'Fax',
  fields: [
    {
      key: 'date',
      label: 'Datum',
      fieldTypes: 'date',
      xsWidth: 6,
    },
    {
      key: 'policeStation',
      label: 'Polizeidienststelle',
      fieldTypes: 'select',
      xsWidth: 6,
      options: [
        {
          value: 'erlangen',
          label: 'Erlangen',
        },
        {
          value: 'fuerth',
          label: 'Fürth',
        },
        {
          value: 'nuremberg',
          label: 'Nürnberg',
        },
        {
          value: 'schwabach',
          label: 'Schwabach',
        },
        {
          value: 'stein',
          label: 'Stein',
        },
        {
          value: 'zirndorf',
          label: 'Zirndorf',
        },
      ],
    },
    {
      key: 'sentFrom',
      label: 'Versendet von',
      fieldTypes: 'select',
      xsWidth: 6,
      options: [
        {
          value: 'hgwClerk',
          label: 'HGW Sachbearbeiter*in',
        },
        {
          value: 'patrolman',
          label: 'Streifenpolizist*in',
        },
        {
          value: 'bpfk',
          label: 'BPFK',
        },
      ],
    },
    {
      key: 'documentLink',
      label: 'Link',
      fieldTypes: 'inputLink',
      xsWidth: 6,
    },
  ],
};

export default faxForm;
